import {
    CHECK_VIDEO_TRANSCODE_STATUS,
    CHECK_VIDEO_TRANSCODE_STATUS_FAILURE, CHECK_VIDEO_TRANSCODE_STATUS_SUCCESS,
    FETCH_AWS_UPLOAD_DETAILS_SUCCESS, RESET_CUSTOM_VIDEO_DIALOG, RESET_UPDATE_ACTIVE_ITEM,
    START_VIDEO_TRANSCODE_FAILURE,
    START_VIDEO_TRANSCODE_SUCCESS,
    UPDATE_ACTIVE_ITEM_FAILURE,
    UPDATE_ACTIVE_ITEM_SUCCESS, UPLOAD_VIDEO_FAILURE,
    UPLOAD_VIDEO_SUCCESS,
    UPLOAD_IMAGE_TO_S3, RESET_UPLOAD_IMAGE_TO_S3, RESET_UPLOAD_CUSTOM_PHOTO_TO_S3, UPLOAD_CUSTOM_PHOTO_TO_S3
} from '../actions/store';

const initialState = {
    fetchAwsUploadDetailsSuccess: null,
    fetchAwsUploadDetailsFailure: null,
    uploadVideoSuccess: null,
    uploadVideoFailure: null,
    startVideoTranscodeSuccess: null,
    startVideoTranscodeFailure: null,
    activeItem: {},
    updateActiveItemSuccess: null,
    updateActiveItemFailure: null,
    uploadImageUrl: null,
    uploadImageError: null,
    uploadCustomPhotoUrl: null,
    uploadCustomPhotoError: null,
    uploadImageToS3Success: null
};

export default function storeReducer(state = initialState, action) {
    switch (action.type) {
        case RESET_UPDATE_ACTIVE_ITEM:
            return {
                ...state,
                activeItem: state.activeItem,
                updateActiveItemSuccess: state.updateActiveItemSuccess,
                updateActiveItemFailure: state.updateActiveItemFailure
            };
        case UPDATE_ACTIVE_ITEM_SUCCESS:
            return {
                ...state,
                activeItem: action.data,
                updateActiveItemSuccess: true,
                updateActiveItemFailure: false
            };
        case UPDATE_ACTIVE_ITEM_FAILURE:
            return {
                ...state,
                updateActiveItemSuccess: false,
                updateActiveItemFailure: true
            };
        case FETCH_AWS_UPLOAD_DETAILS_SUCCESS:
            return {
                ...state,
                fetchAwsUploadDetailsSuccess: true,
                videoUploadUrl: action.data.upload_url,
                videoUploadFile: action.data.file
            };
        case UPLOAD_VIDEO_SUCCESS:
            return {
                ...state,
                uploadVideoSuccess: true
            };
        case UPLOAD_VIDEO_FAILURE:
            return {
                ...state,
                uploadVideoFailure: true
            };
        case START_VIDEO_TRANSCODE_SUCCESS:
            return {
                ...state,
                startVideoTranscodeSuccess: true,
                transcodeVideoId: action.data.id
            };
        case START_VIDEO_TRANSCODE_FAILURE:
            return {
                ...state,
                startVideoTranscodeFailure: true
            };
        case CHECK_VIDEO_TRANSCODE_STATUS:
            return {
                ...state,
                checkVideoTranscodeStatusFailure: null,
                checkVideoTranscodeStatusSuccess: null
            };
        case CHECK_VIDEO_TRANSCODE_STATUS_FAILURE:
            return {
                ...state,
                checkVideoTranscodeStatusFailure: true
            };
        case CHECK_VIDEO_TRANSCODE_STATUS_SUCCESS:
            return {
                ...state,
                checkVideoTranscodeStatusResponse: action.data,
                checkVideoTranscodeStatusSuccess: true,
            };
        case RESET_CUSTOM_VIDEO_DIALOG:
            return {
                ...state,
                fetchAwsUploadDetailsSuccess: null,
                fetchAwsUploadDetailsFailure: null,
                uploadVideoSuccess: null,
                uploadVideoFailure: null,
                startVideoTranscodeSuccess: null,
                startVideoTranscodeFailure: null
            };
        case UPLOAD_IMAGE_TO_S3:
            return {
                ...state,
                uploadImageUrl: action.payload.url,
                uploadImageError: action.error,
                ...(action.meta && action.meta.sent && {
                    uploadImageToS3Success: true
                })
            };
        case RESET_UPLOAD_IMAGE_TO_S3:
            return {
                ...state,
                uploadImageUrl: state.uploadImageUrl,
                uploadImageError: state.uploadImageError,
                uploadImageToS3Success: initialState.uploadImageToS3Success
            };
        case UPLOAD_CUSTOM_PHOTO_TO_S3:
            return {
                ...state,
                uploadCustomPhotoUrl: action.payload.url,
                uploadCustomPhotoError: action.error
            };
        case RESET_UPLOAD_CUSTOM_PHOTO_TO_S3:
            return {
                ...state,
                uploadCustomPhotoUrl: state.uploadCustomPhotoUrl,
                uploadCustomPhotoError: state.uploadCustomPhotoError
            };
        default:
            return state;
    }
}